<template>
    <div style="display: inline-flex">
        <el-select v-model="platform" style="width: 100px" @change="init" filterable :disabled="loading">
          <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"/>
        </el-select>
        <date-range-picker v-model="form" :disabled="loading" start-placeholder="上线开始时间"
                           end-placeholder="上线结束时间" @change="init"></date-range-picker>
        <el-select v-model="form.country" style="width: 200px" @change="init" filterable
                   :disabled="loading" placeholder="全部国家" clearable>
            <el-option v-for="c in $root.country_list" :key="c.code" :value="c.code"
                       :label="c.en_name + ' (' + c.code + ')'">
                {{ c.en_name + ' (' + c.code + ')' }}
            </el-option>
        </el-select>
        <el-select :disabled="loading" v-model="form.video" clearable style="width: 100px" placeholder="激励视频">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <el-select :disabled="loading" v-model="form.animation" clearable style="width: 100px" placeholder="是否动图">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <el-select style="width: 200px" placeholder="模块" filterable v-model="form.module"
                   :disabled="loading" clearable>
          <el-option label="图库" value="LIBRARY"></el-option>
          <el-option label="集合" value="COLLECTION"></el-option>
          <el-option label="每日" value="DAILY"></el-option>
        </el-select>
        <el-select style="width: 160px" placeholder="全部展示来源" filterable
                   v-model="form.source_remote" :disabled="loading" clearable @change="init">
          <el-option label="recommend" value="recommend"></el-option>
          <el-option label="normal" value="normal"></el-option>
          <el-option label="未记录" value="__empty__"></el-option>
        </el-select>
        <el-select style="width: 200px" placeholder="分类" filterable v-model="form.category_id"
                   :disabled="loading" clearable>
            <el-option v-for="c in category_list" :value="c.id" :label="c.i18n_name.ZH_HANS"></el-option>
        </el-select>
        <el-select style="width: 200px" placeholder="来源" filterable v-model="form.source"
                   :disabled="loading" clearable>
            <el-option v-for="c in source_list" :value="c"></el-option>
        </el-select>
        <el-input style="width: 200px" placeholder="ID" v-model="form.id"
                  :disabled="loading"></el-input>
        <el-tooltip content="开启后展示展示量/进入数/进入率/完成率/分享率的 PV 数据列" placement="top">
          <el-switch v-model="showPv" style="margin-left: 8px" :disabled="loading">显示PV</el-switch>
        </el-tooltip>
    </div>
    <div class="table-wrap" style="margin-top: 10px; position: relative">
        <downloadable-table title="素材评分" :data="dataPage" v-loading="false" style="position: relative"
                            :summaryMethod="summaryMethod" show-summary @sort-change="sortChange" :complete="dataDisplayList">
        <el-table-column label="ID" width="150" prop="image_id"></el-table-column>
        <el-table-column label="预览图" width="120">
            <template #default="scope">
                <el-image style="width: 100px" lazy
                          :src="`https://jigsaw-cdn.plutodesk.com/${scope.row.thumbnail}`"></el-image>
            </template>
        </el-table-column>
        <el-table-column label="分类" width="80" prop="categories" sortable="custom">
            <template #default="scope">
                <template v-for="c in scope.row.categories">
                    <template v-for="cate in category_list">
                        <el-tag v-if="c === cate.id">{{ cate.i18n_name.ZH_HANS }}</el-tag>
                    </template>
                </template>
            </template>
        </el-table-column>
        <el-table-column label="模块" width="100" prop="module"></el-table-column>
        <el-table-column label="展示来源" width="120" prop="source_remote">
            <template #default="scope">
                {{ sourceRemoteLabel(scope.row.source_remote) }}
            </template>
        </el-table-column>
        <el-table-column label="平台" width="100" prop="platform"></el-table-column>
        <el-table-column label="激励" width="80" prop="level">
            <template #default="scope">
                {{ scope.row.cost ? '是' : '否' }}
            </template>
        </el-table-column>
        <el-table-column label="动图" width="80">
          <template #default="scope">
            {{ scope.row.animation ? '是' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="上线时间" width="140" prop="create_date" sortable="custom"></el-table-column>
        <el-table-column label="列表综合评分" width="120" prop="final_score" sortable="custom">
            <template #default="scope">
                <el-tooltip v-if="scope.row.scoreDetail" placement="left" effect="dark">
                    <template #content>
                        <div class="score-detail-tooltip">
                            <div class="score-detail-row"><strong>综合评分计算</strong></div>
                            <div class="score-detail-row">K（展示UV中位数）= {{ scope.row.scoreDetail.K }}</div>
                            <div class="score-detail-row">模型 = {{ scope.row.scoreDetail.modelType }}</div>
                            <div class="score-detail-row">权重 = {{ scope.row.scoreDetail.weights }}</div>
                            <div class="score-detail-row">激励进入修正系数 = {{ scope.row.scoreDetail.rewarded_enter_multiplier || 1 }}</div>
                            <div class="score-detail-row">全局平均进入率 = {{ (scope.row.scoreDetail.global_avg_ctr * 100).toFixed(2) }}%</div>
                            <div v-if="scope.row.scoreDetail.global_avg_share != null" class="score-detail-row">全局平均分享率 = {{ (scope.row.scoreDetail.global_avg_share * 100).toFixed(2) }}%</div>
                            <div class="score-detail-row score-detail-divider">本行指标值（平滑后）</div>
                            <div class="score-detail-row">平滑进入率 = {{ (scope.row.scoreDetail.smooth_enter_rate * 100).toFixed(2) }}%</div>
                            <div class="score-detail-row">完成率(u) = {{ (scope.row.scoreDetail.finish_rate_u * 100).toFixed(2) }}%</div>
                            <div v-if="scope.row.scoreDetail.smooth_share_rate != null" class="score-detail-row">平滑分享率 = {{ (scope.row.scoreDetail.smooth_share_rate * 100).toFixed(2) }}%</div>
                            <div class="score-detail-row score-detail-divider">各指标对综合评分的贡献</div>
                            <div v-for="(line, idx) in scope.row.scoreDetail.contributionLines" :key="idx" class="score-detail-row">{{ line }}</div>
                            <div class="score-detail-row score-detail-divider">得分原因（解释）</div>
                            <div class="score-detail-row">z 参考：|z|&lt;0.3 接近均值；0.3~1 轻度偏离；1~2 明显偏离；&gt;2 非常突出</div>
                            <div class="score-detail-row" v-for="(line, idx) in scope.row.scoreDetail.reasonSummaryLines" :key="'sum-' + idx">{{ line }}</div>
                            <div class="score-detail-row" v-for="(line, idx) in scope.row.scoreDetail.reasonLines" :key="'reason-' + idx">{{ line }}</div>
                            <div class="score-detail-row">合计 = {{ (scope.row.final_score).toFixed(2) }}</div>
                            <div class="score-detail-row score-detail-divider">等级划分</div>
                            <div class="score-detail-row">优秀 ≥ {{ scope.row.scoreDetail.thresholdHigh.toFixed(2) }}，糟糕 ≤ {{ scope.row.scoreDetail.thresholdLow.toFixed(2) }}</div>
                        </div>
                    </template>
                    <span class="score-cell-trigger">
                        <span v-if="scope.row.final_score != null">{{ (scope.row.final_score).toFixed(2) }}</span>
                        <span v-else>-</span>
                        <el-tag v-if="scope.row.quality_level === '优秀'" type="success" size="small" style="margin-left: 4px">优秀</el-tag>
                        <el-tag v-else-if="scope.row.quality_level === '糟糕'" type="danger" size="small" style="margin-left: 4px">糟糕</el-tag>
                        <el-tag v-else type="info" size="small" style="margin-left: 4px">普通</el-tag>
                    </span>
                </el-tooltip>
                <template v-else>
                    <span v-if="scope.row.final_score != null">{{ (scope.row.final_score).toFixed(2) }}</span>
                    <span v-else>-</span>
                    <el-tag v-if="scope.row.quality_level === '优秀'" type="success" size="small" style="margin-left: 4px">优秀</el-tag>
                    <el-tag v-else-if="scope.row.quality_level === '糟糕'" type="danger" size="small" style="margin-left: 4px">糟糕</el-tag>
                    <el-tag v-else type="info" size="small" style="margin-left: 4px">普通</el-tag>
                </template>
            </template>
        </el-table-column>
        <el-table-column label="3日价值">
            <el-table-column v-if="showPv" label="展示" prop="impression_3" width="100" sortable="custom"></el-table-column>
            <el-table-column label="展示(u)" prop="impression_u_3" width="100" sortable="custom"></el-table-column>
            <el-table-column v-if="showPv" label="进入数" prop="enter_3" width="100" sortable="custom"></el-table-column>
            <el-table-column label="进入数(u)" prop="enter_u_3" width="100" sortable="custom"></el-table-column>
            <el-table-column v-if="showPv" label="进入率" prop="enter_rate_3" width="100" sortable="custom">
                <template #default="scope">
                    {{ scope.row.enter_rate_3 }}%
                </template>
            </el-table-column>
            <el-table-column label="进入率(u)" prop="enter_rate_u_3" width="100" sortable="custom">
                <template #default="scope">
                    {{ scope.row.enter_rate_u_3 }}%
                </template>
            </el-table-column>
            <el-table-column v-if="showPv" label="完成率" prop="finish_rate_3" width="100" sortable="custom">
                <template #default="scope">
                    {{ scope.row.finish_rate_3 }}%
                </template>
            </el-table-column>
            <el-table-column label="完成率(u)" prop="finish_rate_u_3" width="100" sortable="custom">
                <template #default="scope">
                    {{ scope.row.finish_rate_u_3 }}%
                </template>
            </el-table-column>
            <el-table-column v-if="showPv" label="分享率" prop="share_rate_3" width="100" sortable="custom">
                <template #default="scope">
                    {{ scope.row.share_rate_3 }}%
                </template>
            </el-table-column>
            <el-table-column label="分享率(u)" prop="share_rate_u_3" width="100" sortable="custom">
                <template #default="scope">
                    {{ scope.row.share_rate_u_3 }}%
                </template>
            </el-table-column>
        </el-table-column>
        </downloadable-table>
        <!-- 整表加载：请求 + 算率排序 + 综合评分，在表格区域（原 loading 图标处）展示进度与说明 -->
        <div v-if="tableLoading" class="table-loading-overlay">
            <div class="table-loading-content">
                <el-icon class="is-loading" :size="28" style="margin-bottom: 8px"><Loading /></el-icon>
                <div class="table-loading-status">{{ tableStatus }}</div>
                <el-progress :percentage="tableProgress" :stroke-width="10" style="width: 220px; margin-top: 6px" />
                <div v-if="tableEstimate" class="table-loading-estimate">{{ tableEstimate }}</div>
            </div>
        </div>
    </div>
    <div style="margin-top: 20px;text-align: center">
        <div style="display: inline-flex; align-items: center; gap: 10px">
          <el-pagination v-model:current-page="page" :page-size="size" layout="prev, pager, next"
                         :total="dataDisplayList.length"></el-pagination>
          <el-select v-model="size" style="width: 120px" :disabled="loading" @change="page = 1">
            <el-option v-for="s in [20, 50, 100, 200]" :key="s" :label="`${s}/页`" :value="s"></el-option>
          </el-select>
        </div>
    </div>
</template>

<script>
import axios from "ts-axios-new";
import { ElMessage } from "element-plus";
import DateRangePicker from "../base/DateRangePicker";
import DownloadableTable from "../base/DownloadableTable";
import { Loading } from '@element-plus/icons-vue';

export default {
    name: "Score",
    components: { DownloadableTable, DateRangePicker, Loading },
    data() {
        return {
            loading: false, category_list: [], data: [], page: 1, size: 20, source_list: [], platform: 'android',
            showPv: false,
            dataFilterWithScore: [],
            dataVersion: 0,
            scoreLoading: false,
            scoreProgress: 0,
            sortState: { prop: null, order: null },
            loadingStatus: '',
            loadingProgress: 0,
            loadingStartTime: 0,
            _estimateTick: 0,
            _estimateTimer: null,
            _scoreComputeId: 0,
            _scoreComputeTimer: null,
            form: {
                start: null,
                end: null,
                country: null,
                category_id: null,
                module: null,
                video: null,
                animation: null,
                enter: 1,
                finish: 2,
                download: 4,
                share: 5,
                id: null,
                key: null,
                author: null,
                source: null,
                source_remote: null,
            }
        }
    },
    methods: {
        sourceRemoteLabel(sourceRemote) {
            if (sourceRemote === '__all__') return '全部';
            if (sourceRemote == null || sourceRemote === '') return '未记录';
            return sourceRemote;
        },
        metricRowKey(row) {
            return [row?.image_id || '', row?.create_date || '', row?.source_remote || ''].join('\u001f');
        },
        init() {
            this.loading = true;
            this.loadingStatus = '正在请求数据…';
            this.loadingProgress = 0;
            this.loadingStartTime = Date.now();
            let metricList = [];
            return axios.all([
                axios.get(`/cms/v1/metric`, {
                    params: {
                        country: this.form.country,
                        start: this.form.start,
                        end: this.form.end,
                        platform: this.platform,
                        source_remote: this.form.source_remote,
                    }
                }).then(res => {
                    metricList = res.data.data.metricList || [];
                }), axios.get('/cms/v1/source').then(res => {
                    this.source_list = [];
                    res.data.data.sourceList.forEach(s => {
                        if (s && !this.source_list.includes(s)) {
                            this.source_list.push(s);
                        }
                    });
                }),
            ]).then(_ => {
                const n = metricList?.length ?? 0;
                this.loadingStatus = `正在处理数据（计算率、排序）${n ? `，共 ${n} 条` : ''}…`;
                this.loadingProgress = 10;
                console.log('[Score] 接口已返回，下一帧开始处理数据（计算率、排序）…', n, '条');
                setTimeout(() => {
                    console.log('[Score] 开始处理数据（计算率、排序）');
                    this.loadingProgress = 15;
                    metricList.forEach(d => {
                        d.enter_rate_3 = d.impression_3 ? parseInt(d.enter_3 / d.impression_3 * 10000) / 100.0 : null;
                        d.finish_rate_3 = parseInt(d.finish_3 / d.enter_3 * 10000) / 100.0 || 0;
                        d.bomb_3 = parseInt(d.bomb_3 / d.enter_3 * 100) / 100.0 || 0;
                        d.bucket_3 = parseInt(d.bucket_3 / d.enter_3 * 100) / 100.0 || 0;
                        d.magic_3 = parseInt(d.magic_3 / d.enter_3 * 100) / 100.0 || 0;
                        d.download_rate_3 = parseInt(d.download_3 / d.finish_3 * 10000) / 100.0 || 0;
                        d.share_rate_3 = parseInt(d.share_3 / d.finish_3 * 10000) / 100.0 || 0;
                        d.enter_rate_7 = d.impression_7 ? parseInt(d.enter_7 / d.impression_7 * 10000) / 100.0 : null;
                        d.finish_rate_7 = parseInt(d.finish_7 / d.enter_7 * 100) / 100.0 || 0;
                        d.share_rate_7 = parseInt(d.share_7 / d.finish_7 * 10000) / 100.0 || 0;
                        d.enter_rate_u_3 = d.impression_u_3 ? parseInt(d.enter_u_3 / d.impression_u_3 * 10000) / 100.0 : null;
                        d.finish_rate_u_3 = parseInt(d.finish_u_3 / d.enter_u_3 * 10000) / 100.0 || 0;
                        d.share_rate_u_3 = parseInt(d.share_u_3 / d.finish_u_3 * 10000) / 100.0 || 0;
                    });
                    this.sortChange({});
                    this.data = metricList;
                    this.dataVersion += 1;
                    this.loadingProgress = 25;
                    console.log('[Score] 数据处理完成，表格可展示');
                    this.loading = false;
                }, 0);
            }).catch(err => {
                // 请求失败时必须收起整表 loading，否则页面会一直停在「正在请求数据…」
                console.warn('[Score] 数据请求失败', err);
                this.loading = false;
                this.loadingStatus = '';
                this.loadingProgress = 0;
                this.scoreLoading = false;
                this.scoreProgress = 0;
                this.data = [];
                const status = err?.response?.status;
                const msg = err?.response?.data?.status?.msg || err?.response?.data?.status?.message;
                ElMessage.error(status ? `素材评分数据加载失败（HTTP ${status}）${msg ? '：' + String(msg).slice(0, 200) : ''}` : '素材评分数据加载失败，请稍后重试');
            })
        },
        resort() {
            this.data.forEach(d => {
                d.score = this.form.enter * d.enter_7 + this.form.finish * d.finish_7 / d.enter_7 + this.form.download * d.download_7 / d.finish_7 + this.form.share * d.share_7 / d.finish_7;
            });
            this.data.sort(function (a, b) {
                return b.score - a.score;
            })
        },
        sortChange({ prop, order } = {}) {
            this.sortState = { prop: prop || null, order: order || null };
            this.page = 1;
        },
        isEmptySortValue(value) {
            return value == null || (typeof value === 'number' && Number.isNaN(value));
        },
        normalizeSortValue(value, prop) {
            if (this.isEmptySortValue(value)) return value;
            if (prop === 'create_date') {
                const time = new Date(value).getTime();
                return Number.isNaN(time) ? value : time;
            }
            if (Array.isArray(value)) return value.join(',');
            const numericValue = typeof value === 'string' && value.trim() !== '' ? Number(value) : value;
            return typeof numericValue === 'number' && !Number.isNaN(numericValue) ? numericValue : value;
        },
        compareSortValue(a, b, prop, order) {
            const va = this.normalizeSortValue(a?.[prop], prop);
            const vb = this.normalizeSortValue(b?.[prop], prop);
            const aEmpty = this.isEmptySortValue(va);
            const bEmpty = this.isEmptySortValue(vb);
            if (aEmpty && bEmpty) return 0;
            if (aEmpty) return 1;
            if (bEmpty) return -1;

            let cmp = 0;
            if (typeof va === 'number' && typeof vb === 'number') {
                cmp = va - vb;
            } else {
                cmp = String(va).localeCompare(String(vb), 'zh-Hans', { numeric: true, sensitivity: 'base' });
            }
            return order === 'descending' ? -cmp : cmp;
        },
        summaryMethod({columns, data}) {
          const summary = [];
          let enter = 0, impression = 0, finish = 0, share = 0;
          let enter_u = 0, impression_u = 0, finish_u = 0, share_u = 0;
          let hint = 0, duration = 0, t = 0, exit = 0;
          this.dataFilter.forEach(d => {
            enter += d.enter_3 || 0;
            impression += d.impression_3 || 0;
            finish += d.finish_3 || 0;
            share += d.share_3 || 0;
            enter_u += d.enter_u_3 || 0;
            impression_u += d.impression_u_3 || 0;
            finish_u += d.finish_u_3 || 0;
            share_u += d.share_u_3 || 0;
            // hint += d.hint_3;
            // duration += d.duration_3;
            // exit += d.exit_3;
            t += 1;
          });
          columns.forEach((c, i) => {
            if (c.property === 'enter_3') {
              summary[i] = t ? Math.round(enter / t) : '';
            } else if (c.property === 'impression_3') {
              summary[i] = t ? Math.round(impression / t) : '';
            } else if (c.property === 'enter_rate_3') {
              summary[i] = impression ? (parseInt(enter / impression * 10000) / 100 + '%') : '';
            } else if (c.property === 'finish_rate_3') {
              summary[i] = enter ? (parseInt(finish / enter * 10000) / 100 + '%') : '';
            } else if (c.property === 'share_rate_3') {
              summary[i] = finish ? (parseInt(share / finish * 10000) / 100 + '%') : '';
            } else if (c.property === 'enter_u_3') {
              summary[i] = t ? Math.round(enter_u / t) : '';
            } else if (c.property === 'impression_u_3') {
              summary[i] = t ? Math.round(impression_u / t) : '';
            } else if (c.property === 'enter_rate_u_3') {
              summary[i] = impression_u ? (parseInt(enter_u / impression_u * 10000) / 100 + '%') : '';
            } else if (c.property === 'finish_rate_u_3') {
              summary[i] = enter_u ? (parseInt(finish_u / enter_u * 10000) / 100 + '%') : '';
            } else if (c.property === 'share_rate_u_3') {
              summary[i] = finish_u ? (parseInt(share_u / finish_u * 10000) / 100 + '%') : '';
            }
            // } else if (c.property === 'hint_3') {
            //   summary[i] = (hint / enter).toFixed(2);
            // } else if (c.property === 'duration_3') {
            //   summary[i] = (duration / enter).toFixed(2) + '秒';
            // } else if (c.property === 'duration_3_new') {
            //   if (exit) {
            //     summary[i] = (duration / exit).toFixed(2) + '秒';
            //   }
            // }
          });
          return summary;
        },
        /** 基于当前筛选后的全量数据计算列表综合评分（贝叶斯平滑 + 双阶归一化）。可传 onProgress 做异步进度回调。 */
        async computeFinalScores(list, onProgress) {
            const yieldProgress = onProgress ? async (p) => {
                this.scoreProgress = p;
                console.log('[Score] 进度', p + '%');
                await this.$nextTick();
                // 等浏览器真正画出一帧，否则主线程马上被后续计算占满，界面来不及从 0% 更新到 p%
                await new Promise(r => requestAnimationFrame(r));
                await new Promise(r => requestAnimationFrame(r));
            } : null;

            console.log('[Score] 计算开始', { rows: list?.length ?? 0 });
            if (yieldProgress) await yieldProgress(1);

            if (!list || list.length === 0) {
                console.log('[Score] 计算结束（无数据）');
                return list ? list.slice() : [];
            }
            const arr = list.map(r => ({ ...r }));
            if (yieldProgress) await yieldProgress(2);

            const impU = arr.map(r => r.impression_u_3);
            const validImp = impU.filter(v => v != null && !isNaN(v) && v > 0);
            if (validImp.length === 0) {
                arr.forEach(r => { r.final_score = null; r.quality_level = null; });
                console.log('[Score] 计算结束（无有效展示UV）');
                return arr;
            }
            const median = (a) => {
                const s = a.slice().sort((x, y) => x - y);
                const m = Math.floor(s.length / 2);
                return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
            };
            const K = median(validImp);

            const isRewarded = (row) => !!((row && row.cost && Number(row.cost) > 0) || (row && row.video === true));
            const rewardedEnterMultiplier = 1.3;
            const sum = (a, key) => a.reduce((acc, r) => acc + (Number(r[key]) || 0), 0);
            const sumImpU = sum(arr, 'impression_u_3');
            const sumEnterU = sum(arr, 'enter_u_3');
            const sumEnterUAdjusted = arr.reduce((acc, r) => {
                const enter = Number(r.enter_u_3) || 0;
                return acc + (isRewarded(r) ? enter * rewardedEnterMultiplier : enter);
            }, 0);
            if (sumImpU <= 0) {
                arr.forEach(r => { r.final_score = null; r.quality_level = null; });
                console.log('[Score] 计算结束（sumImpU<=0）');
                return arr;
            }
            // 激励素材进入门槛更高，进入数按 1.3 倍参与整体与个体进入率计算
            const global_avg_ctr = sumEnterUAdjusted / sumImpU;
            if (yieldProgress) await yieldProgress(5);

            arr.forEach(r => {
                const imp = r.impression_u_3 != null ? Number(r.impression_u_3) : 0;
                const rawEnter = r.enter_u_3 != null ? Number(r.enter_u_3) : 0;
                const enter = isRewarded(r) ? rawEnter * rewardedEnterMultiplier : rawEnter;
                r._smooth_enter_rate = (enter + K * global_avg_ctr) / (imp + K);
                r._finish_rate_u = (r.finish_rate_u_3 != null && !isNaN(r.finish_rate_u_3)) ? (Number(r.finish_rate_u_3) / 100) : 0;
            });
            if (yieldProgress) await yieldProgress(10);

            let global_avg_share = null;
            // 仅当「没有任何一行缺少分享率（无 null/NaN/0）」且「有分享数据」时用三维；任一行分享率为 0 或缺失则用二维
            const hasShare =
                !arr.some(r => {
                    const rate = r.share_rate_u_3;
                    if (rate == null || isNaN(rate)) return true;
                    if (Number(rate) === 0) return true;
                    return false;
                }) &&
                arr.reduce((acc, r) => acc + (Number(r.share_rate_u_3) || 0), 0) > 0 &&
                sumEnterU > 0;
            if (hasShare && sumEnterU > 0) {
                const sumShareU = sum(arr, 'share_u_3');
                global_avg_share = sumShareU / sumEnterU;
                arr.forEach(r => {
                    const enter = r.enter_u_3 != null ? Number(r.enter_u_3) : 0;
                    const share = r.share_u_3 != null ? Number(r.share_u_3) : 0;
                    r._smooth_share_rate = (enter + K / 10) > 0
                        ? (share + (K / 10) * global_avg_share) / (enter + K / 10)
                        : 0;
                });
            }
            if (yieldProgress) await yieldProgress(20);

            const metricNames = hasShare ? ['平滑进入率', '完成率(u)', '平滑分享率'] : ['平滑进入率', '完成率(u)'];
            const metrics = hasShare ? ['_smooth_enter_rate', '_finish_rate_u', '_smooth_share_rate'] : ['_smooth_enter_rate', '_finish_rate_u'];
            const weights = hasShare ? [0.6, 0.3, 0.1] : [0.7, 0.3];
            const weightsStr = weights.join(', ');

            const sourceLabel = () => '全局';
            const zLabel = (v) => v >= 1 ? '明显高于全局均值' : v >= 0.3 ? '略高于全局均值' : v > -0.3 ? '接近全局均值' : v > -1 ? '低于全局均值' : '明显低于全局均值';

            const mean = (vals) => vals.length ? vals.reduce((a, b) => a + b, 0) / vals.length : 0;
            const std = (vals, m) => {
                if (vals.length <= 1) return 0;
                const v = vals.reduce((acc, x) => acc + (x - m) ** 2, 0) / vals.length;
                return Math.sqrt(v) || 0;
            };

            arr.forEach(r => { r.final_score = 0; r._contribs = []; r._metricDebugs = []; });

            // 20%～80% 按「每个指标 + 行内分块」分配，7k 条时主要耗时在这里，需按行数 yield 才能反映真实进度
            const totalMetrics = metrics.length;
            const progressRange = 60; // 20 -> 80
            const yieldChunk = Math.max(300, Math.floor(arr.length / 20)); // 每约 5% 行数 yield 一次，最少 300 行
            for (let idx = 0; idx < metrics.length; idx++) {
                const metricKey = metrics[idx];
                const w = weights[idx];
                const allVals = arr.map(r => r[metricKey] != null ? Number(r[metricKey]) : 0);
                const all_mu = mean(allVals);
                const all_sigma = std(allVals, all_mu);

                const progressStart = 20 + (idx / totalMetrics) * progressRange;
                const progressEnd = 20 + ((idx + 1) / totalMetrics) * progressRange;
                for (let i = 0; i < arr.length; i++) {
                    const r = arr[i];
                    const x = r[metricKey] != null ? Number(r[metricKey]) : 0;
                    const daily_z = all_sigma > 0 ? (x - all_mu) / all_sigma : 0;
                    const day_quality_offset = 0;
                    const contrib = daily_z * w;
                    r.final_score += contrib;
                    r._contribs.push(contrib);
                    r._metricDebugs.push({
                        name: metricNames[idx],
                        x,
                        groupMean: all_mu,
                        groupSigma: all_sigma,
                        dailyZ: daily_z,
                        dayQualityOffset: day_quality_offset,
                        statSource: 'global',
                        contrib,
                    });
                    if (yieldProgress && i > 0 && i % yieldChunk === 0) {
                        const p = progressStart + ((i + 1) / arr.length) * (progressEnd - progressStart);
                        await yieldProgress(Math.round(p));
                    }
                }
                if (yieldProgress) await yieldProgress(Math.round(progressEnd));
            }

            const scores = arr.map(r => r.final_score);
            const sorted = scores.slice().sort((a, b) => a - b);
            const q95Idx = Math.min(Math.ceil(0.95 * sorted.length) - 1, sorted.length - 1);
            const q5Idx = Math.max(Math.floor(0.05 * sorted.length) - 1, 0);
            const thresholdLow = sorted.length ? sorted[Math.max(0, q5Idx)] : 0;
            const thresholdHigh = sorted.length ? sorted[Math.max(0, q95Idx)] : 0;

            if (yieldProgress) await yieldProgress(90);

            arr.forEach(r => {
                r.quality_level = r.final_score >= thresholdHigh ? '优秀' : r.final_score <= thresholdLow ? '糟糕' : '普通';
                const metricDebugs = r._metricDebugs || [];
                const topDrivers = metricDebugs
                    .map((d, i) => ({ ...d, idx: i, absContrib: Math.abs(d.contrib || 0) }))
                    .sort((a, b) => b.absContrib - a.absContrib)
                    .slice(0, 2);
                r.scoreDetail = {
                    K,
                    modelType: hasShare ? '三维评估模型（含分享）' : '二维评估模型（无分享）',
                    weights: weightsStr,
                    global_avg_ctr: global_avg_ctr,
                    rewarded_enter_multiplier: rewardedEnterMultiplier,
                    global_avg_share: global_avg_share,
                    smooth_enter_rate: r._smooth_enter_rate,
                    finish_rate_u: r._finish_rate_u,
                    smooth_share_rate: r._smooth_share_rate != null ? r._smooth_share_rate : null,
                    contributionLines: metricNames.map((name, i) => `${name}(${weights[i]}): ${(r._contribs[i] != null ? r._contribs[i] : 0).toFixed(3)}`),
                    reasonSummaryLines: topDrivers.map(d =>
                        `${d.name}是主要${d.contrib >= 0 ? '加分' : '减分'}项（${(d.contrib || 0).toFixed(3)}），核心原因：${zLabel(d.dailyZ)}。`
                    ),
                    reasonLines: metricDebugs.map(d =>
                        `${d.name}：贡献=${(d.contrib || 0).toFixed(3)}；基线=${sourceLabel(d.statSource)}；${zLabel(d.dailyZ)}（z=${d.dailyZ.toFixed(3)}）；全局均值=${(d.groupMean * 100).toFixed(2)}%，全局标准差=${(d.groupSigma * 100).toFixed(2)}%。`
                    ),
                    thresholdLow,
                    thresholdHigh,
                };
                delete r._smooth_enter_rate;
                delete r._finish_rate_u;
                delete r._smooth_share_rate;
                delete r._contribs;
                delete r._metricDebugs;
            });

            if (yieldProgress) await yieldProgress(100);
            console.log('[Score] 计算结束', { rows: arr.length });
            return arr;
        },
    },
    mounted() {
        this.loading = true;
        axios.get('/cms/v1/category').then(res => {
            this.category_list = res.data.data.categoryList;
            this.init();
        }).catch(err => {
            // 分类接口失败不应阻塞评分数据：否则 init 不会执行，页面会一直停在「加载中…」
            console.warn('[Score] 分类加载失败', err);
            this.category_list = [];
            this.init();
        })
    },
    computed: {
        dataFilter() {
            return this.data.filter(d => {
                let valid = d.impression_3 > 100;
                valid &= !this.form.id || d.image_id.includes(this.form.id);
                valid &= !this.form.key || d.key && d.key.includes(this.form.key);
                valid &= !this.form.category_id || d.categories && d.categories.includes(this.form.category_id);
                valid &= !this.form.source || d.source === this.form.source;
                valid &= !this.form.module || d.module === this.form.module;
                valid &= this.form.video == null || (this.form.video && d.cost && d.cost > 0) || (!this.form.video && !d.cost)
                valid &= this.form.animation == null || Boolean(d.animation) === this.form.animation;
              return valid;
            })
        },
        /** 仅当数据版本或筛选集合变化时触发重算，排序不改变集合，故不会重算 */
        dataFilterIdKey() {
            const list = this.dataFilter;
            if (!list || list.length === 0) return '';
            return `${this.dataVersion}:${list.map(r => this.metricRowKey(r)).sort().join(',')}`;
        },
        /** 按当前 dataFilter 顺序展示带分数据（排序只改顺序，不重算分）。用 Map 做 O(1) 查找避免 O(n²) 卡顿。 */
        dataFilterWithScoreOrdered() {
            const list = this.dataFilter;
            const scored = this.dataFilterWithScore || [];
            if (!list.length) return [];
            const scoredMap = new Map(scored.map(s => [this.metricRowKey(s), s]));
            return list.map(row => {
                const scoredRow = scoredMap.get(this.metricRowKey(row));
                return scoredRow
                    ? { ...row, final_score: scoredRow.final_score, quality_level: scoredRow.quality_level, scoreDetail: scoredRow.scoreDetail }
                    : { ...row, final_score: null, quality_level: null, scoreDetail: null };
            });
        },
        dataDisplayList() {
            const prop = this.sortState.prop || 'enter_rate_3';
            const order = this.sortState.order || 'descending';
            return this.dataFilterWithScoreOrdered
                .map((row, index) => ({ row, index }))
                .sort((a, b) => this.compareSortValue(a.row, b.row, prop, order) || a.index - b.index)
                .map(({ row }) => row);
        },
        dataPage() {
            return this.dataDisplayList.slice((this.page - 1) * this.size, this.page * this.size);
        },
        tableLoading() {
            return this.loading || this.scoreLoading;
        },
        tableProgress() {
            if (this.loading) return this.loadingProgress;
            return Math.round(25 + this.scoreProgress * 0.75);
        },
        tableStatus() {
            if (this.loading) return this.loadingStatus || '加载中…';
            return `正在计算综合评分 ${this.scoreProgress}%`;
        },
        tableEstimate() {
            void this._estimateTick;
            if (!this.tableLoading || this.tableProgress < 5 || this.tableProgress >= 99) return '';
            const elapsed = (Date.now() - this.loadingStartTime) / 1000;
            const remaining = elapsed * (100 - this.tableProgress) / this.tableProgress;
            const s = Math.max(1, Math.round(remaining));
            return s >= 60 ? `预计剩余约 ${Math.round(s / 60)} 分钟` : `预计剩余 ${s} 秒`;
        },
    },
    watch: {
        dataFilterIdKey: {
            handler(idKey) {
                if (this._scoreComputeTimer != null) {
                    cancelAnimationFrame(this._scoreComputeTimer);
                    this._scoreComputeTimer = null;
                }
                const id = ++this._scoreComputeId;
                this.dataFilterWithScore = [];
                if (!idKey) {
                    this.scoreLoading = false;
                    this.scoreProgress = 0;
                    this.loadingStatus = '';
                    this.loadingProgress = 0;
                    return;
                }
                const list = this.dataFilter;
                this.scoreLoading = true;
                this.scoreProgress = 0;
                if (!this.loadingStartTime) this.loadingStartTime = Date.now();
                console.log('[Score] 准备开始计算，等待下一帧绘制进度条…');
                // 双 rAF：确保浏览器先画出进度条再开始计算，避免「先选日期再算」等场景下进度条不出现
                const run = () => {
                    this._scoreComputeTimer = null;
                    this.computeFinalScores(list, (p) => { this.scoreProgress = p; }).then(result => {
                        if (id !== this._scoreComputeId) return;
                        this.dataFilterWithScore = result;
                        this.scoreLoading = false;
                        this.scoreProgress = 100;
                        this.loadingStatus = '';
                        this.loadingProgress = 100;
                        console.log('[Score] 结果已应用，进度条关闭');
                    }).catch((err) => {
                        if (id !== this._scoreComputeId) return;
                        this.scoreLoading = false;
                        this.scoreProgress = 0;
                        console.warn('[Score] 计算异常', err);
                    });
                };
                const schedule = () => {
                    this._scoreComputeTimer = requestAnimationFrame(() => {
                        this._scoreComputeTimer = requestAnimationFrame(run);
                    });
                };
                schedule();
            },
            immediate: true,
        },
        tableLoading: {
            handler(v) {
                if (v) {
                    if (this._estimateTimer) clearInterval(this._estimateTimer);
                    this._estimateTimer = setInterval(() => { this._estimateTick++; }, 1000);
                } else {
                    if (this._estimateTimer) clearInterval(this._estimateTimer);
                    this._estimateTimer = null;
                    this.loadingStartTime = 0;
                }
            },
        },
    },
    beforeUnmount() {
        if (this._scoreComputeTimer != null) cancelAnimationFrame(this._scoreComputeTimer);
        if (this._estimateTimer) clearInterval(this._estimateTimer);
    },
}
</script>

<style scoped>
.table-wrap {
    min-height: 200px;
}
.table-loading-overlay {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: var(--el-overlay-color-lighter);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}
.table-loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background: var(--el-bg-color);
    border-radius: 8px;
    box-shadow: var(--el-box-shadow-light);
}
.table-loading-status {
    font-size: 14px;
    color: var(--el-text-color-regular);
    max-width: 280px;
    text-align: center;
}
.table-loading-estimate {
    font-size: 12px;
    color: var(--el-text-color-secondary);
    margin-top: 6px;
}
</style>
<style>
.score-detail-tooltip {
    max-width: 320px;
    font-size: 12px;
    line-height: 1.6;
}
.score-detail-tooltip .score-detail-row {
    margin: 2px 0;
}
.score-detail-tooltip .score-detail-divider {
    margin-top: 6px;
    padding-top: 4px;
    border-top: 1px solid rgba(255,255,255,0.3);
}
</style>
